import { z } from 'zod';
import { guidedSchema } from 'utils/useGuidedModeParam';

export const tabsSchema = <const T extends z.EnumValues>(tabs: T) =>
  z
    .object({
      tab: z.enum(tabs),
    })
    .merge(guidedSchema);
